import { render, staticRenderFns } from "./QuizBySubjectsIndex.vue?vue&type=template&id=b13c3e74"
import script from "./QuizBySubjectsIndex.vue?vue&type=script&lang=js"
export * from "./QuizBySubjectsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports